export const validateField = (fieldName, value, type) => {
  switch (fieldName) {
    case "type":
      return !value.trim() ? "Template type is required." : "";
    case "name":
      return !value.trim() ? "Template name is required." : "";
    case "subject":
      return type === "email_template" && !value.trim()
        ? "Email subject is required for email templates."
        : "";
    case "base_html":
      return !value
        ? "Base HTML file is required."
        : !value.name.toLowerCase().endsWith(".html")
        ? "File must be an HTML (.html) file."
        : "";
    case "placeholders_json":
      return !value
        ? "Placeholders JSON file is required."
        : !value.name.toLowerCase().endsWith(".json")
        ? "File must be a JSON (.json) file."
        : "";
    case "target_languages":
      return value.length === 0 ? "Please select at least one target language." : "";
    case "hasConsented":
      return !value ? "You must select confirm assets checkbox." : "";
    default:
      return "";
  }
};